/*********** Redux-Saga ************/
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import sagas from '../sagas';
import rootReducer from '../reducer';

// create the saga middleware

const sagaMiddleware = createSagaMiddleware();
// mount it on the Store
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware, logger))
);
// then run the saga
sagaMiddleware.run(sagas);

export default () => {
  return { store };
};
